module.exports = __webpack_public_path__ + "img/buddy_antenna-04.6f2ff44b.svg";